<template>
  <div class="modal fade" id="editBehaviorScoreModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            v-if="BehaviorTracker != null && BehaviorTrackerScore != null"
            class="modal-title"
          >
            Edit Behavior Score
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="BehaviorTracker != null" class="modal-body">
          <div v-if="errorMessage != ''" class="text-danger">
            <p>{{ errorMessage }}</p>
          </div>
          <form
            class="text-left mb-4"
            v-if="
              page == 1 &&
                BehaviorTracker != null &&
                BehaviorTracker.Settings.length > 0
            "
          >
            <div class="form-group">
              <label v-bind:for="'trackerDate'">Date</label>
              <input
                type="date"
                class="form-control"
                id="trackerDate"
                v-model="date"
                required
              />
            </div>
            <div class="mb-2">
              <p class="mb-0">For which setting would you like to add data?</p>
            </div>
            <div
              v-for="setting in BehaviorTracker.Settings"
              :key="setting.Behavior_Setting_Id"
            >
              <label
                class="btn btn-sm ml-2"
                v-bind:class="{
                  'btn-primary': formSetting == setting,
                  'btn-outline-primary': formSetting != setting
                }"
                v-bind:for="'setting' + setting.Behavior_Setting_Id"
                ><input
                  type="radio"
                  style="display: none"
                  name="setting"
                  v-bind:id="'setting' + setting.Behavior_Setting_Id"
                  v-bind:value="setting"
                  v-model="formSetting"
                />{{ setting.Title }}</label
              >
            </div>
          </form>
          <div
            v-for="templateInput in BehaviorTracker.Score_Template
              .Score_Template_Inputs"
            :key="templateInput.Score_Template_Input_Id"
          >
            <form v-if="page == 1 + templateInput.Order">
              <EnterBehaviorScoreRow
                v-bind:Input="templateInput"
                v-bind:SettingInputs="settingInputs"
                @input-change="inputChanged"
              />
            </form>
          </div>
          <div
            v-if="
              page ==
                2 + BehaviorTracker.Score_Template.Score_Template_Inputs.length
            "
            class="mb-4 row"
          >
            <div class="col-12">
              <h5 class="mb-0"><strong>Review</strong></h5>
            </div>
            <div
              v-for="settingInput in settingInputs"
              :key="settingInput.setting.Behavior_Setting_Id"
              class="text-left col-6"
            >
              <p class="mb-0 mt-2">
                <strong>{{ settingInput.setting.Title }}</strong>
              </p>
              <div
                v-for="input in settingInput.inputs"
                :key="
                  settingInput.setting.Behavior_Setting_Id +
                    'input' +
                    input.order
                "
              >
                <p class="mb-0">
                  {{
                    BehaviorTracker.Score_Template.Score_Template_Inputs.find(
                      i => i.Order == input.order
                    ).Request
                  }}
                </p>
                <p class="mb-0">
                  <strong>{{
                    $prettifyInput(
                      input.input,
                      BehaviorTracker.Score_Template.Score_Template_Inputs.find(
                        i => i.Order == input.order
                      )
                    )
                  }}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col text-left">
              <button
                v-if="page != 1"
                type="button"
                class="btn btn-danger"
                v-on:click="previousPage"
              >
                Back
              </button>
              <button
                v-else
                type="button"
                class="btn btn-danger"
                v-on:click="cancel"
              >
                Cancel
              </button>
            </div>
            <div class="col-auto">
              <button
                v-if="
                  page ==
                    2 +
                      BehaviorTracker.Score_Template.Score_Template_Inputs
                        .length
                "
                type="button"
                class="btn btn-primary"
                v-on:click="addData"
              >
                Update Data
              </button>
              <button
                v-else
                v-on:click="nextPage"
                type="button"
                class="btn btn-primary"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import EnterBehaviorScoreRow from "@/components/Score/EnterBehaviorScoreRow.vue";

export default {
  components: {
    EnterBehaviorScoreRow
  },
  props: {
    BehaviorTracker: Object,
    BehaviorTrackerScore: Object
  },
  data() {
    return {
      formSetting: null,
      page: 1,
      errorMessage: "",
      settingInputs: [],
      date: this.$dateToYYYYMMDD(new Date())
    };
  },
  watch: {
    BehaviorTrackerScore: function() {
      this.formSetting = this.BehaviorTracker.Settings.find(
        s =>
          s.Behavior_Setting_Id ==
          this.BehaviorTrackerScore.Setting.Behavior_Setting_Id
      );
      var splitDate = this.BehaviorTrackerScore.Date.split("-");
      var year = splitDate[0];
      var month = splitDate[1];
      var day = splitDate[2].split("T")[0];
      this.date = this.$dateToYYYYMMDD(new Date(year, month - 1, day));
    }
  },
  methods: {
    nextPage() {
      switch (this.page) {
        case 1:
          var trackerValue = JSON.parse(
            JSON.stringify(this.BehaviorTrackerScore.Value)
          );
          this.settingInputs = [
            { setting: this.formSetting, inputs: trackerValue }
          ];
          this.page = 2;
          break;
        default:
          this.page = this.page + 1;
          break;
      }
      $("#editBehaviorScoreModal").animate({ scrollTop: 0 }, "slow");
    },
    previousPage() {
      this.page = this.page - 1;
    },
    cancel() {
      $("#editBehaviorScoreModal").modal("hide");
      this.clearForm();
    },
    selectAllSettings() {
      this.formSettings = this.BehaviorTracker.Settings;
    },
    inputChanged(input, settingInput) {
      var settingInputIndex = this.settingInputs.findIndex(
        i =>
          i.setting.Behavior_Setting_Id ==
          settingInput.setting.Behavior_Setting_Id
      );
      var inputIndex = this.settingInputs[settingInputIndex].inputs.findIndex(
        i => i.order == input.Order
      );
      this.settingInputs[settingInputIndex].inputs[
        inputIndex
      ].input = settingInput.inputs.find(i => i.order == input.Order).input;
    },
    async addData() {
      $("#editBehaviorScoreModal").modal("hide");
      this.$store.commit("updateLoading", true);
      var editedScores = [];
      for (let i = 0; i < this.settingInputs.length; i++) {
        const settingInput = this.settingInputs[i];
        await this.$updateBehaviorTrackerScore(
          this.BehaviorTrackerScore.Behavior_Tracker_Score_Id,
          this.BehaviorTracker.Behavior_Tracker_Id,
          settingInput.setting.Behavior_Setting_Id,
          this.date,
          settingInput.inputs
        ).then(res => {
          editedScores.push({
            Setting: settingInput.setting,
            Date: res.Date,
            Behavior_Tracker_Score_Id: res.Behavior_Tracker_Score_Id,
            Value: settingInput.inputs
          });
        });
      }
      this.page = 1;
      this.$store.commit("updateLoading", false);
      this.$emit("edited-scores", editedScores);
      this.clearForm();
    },
    clearForm() {
      this.formSetting = null;
      this.page = 1;
      this.errorMessage = "";
      this.settingInputs = [];
      this.date = this.$dateToYYYYMMDD(new Date());
    }
  }
};
</script>
